import Api from '../Api';

import { url } from './config';
import { PassengerAttribute } from './model';

const api = new Api<PassengerAttribute>(url);

export default api;
